"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringArrayRotateFunctionTemplate = void 0;
function StringArrayRotateFunctionTemplate() {
    return `
        (function (array, {timesName}) {
            const {whileFunctionName} = function (times) {
                while (--times) {
                    array['push'](array['shift']());
                }
            };
            
            {code}
        })({stringArrayName}, {stringArrayRotationAmount});
    `;
}
exports.StringArrayRotateFunctionTemplate = StringArrayRotateFunctionTemplate;
